<template>
  <div class="FansDemandPoolList demand-list">
    <div class="inner_center">

      <div v-for="(vo,idx) in list"
           :key="idx"
           class="demand-item"
           :class="{ 'demand-item-ranking': idx == 3 }"
      >
        <a
          :key="idx"
          :href="vo._link"
          target="_blank"
          v-if="Object.keys(vo).length > 0"
        >
          <div class="demand-item-pic"
          >
            <div class="pic-mask"></div>
            <div class="pic-color-mask"></div>
            <img :src="vo._case_material_url" alt="">


            <!--  我也想 +1  -->
            <div class="demand-support _user-select">
              <!-- 未想要 -->

              <template v-if="type != 'oneself'">
                <div class="collect-default" v-if="vo.is_collected == 0"
                     @click.prevent.stop="toggleCollect({vo,idx})">
                  我想要
                  <span class="line"></span>
                  +1
                </div>

                <!--  同求 -->
                <div class="collect-succ" v-else
                     @click.prevent.stop="toggleCollect({vo,idx})">
                  <div class="collect-person">{{ vo.collect_users }}人同求</div>
                  <div class="collect-cancel">取消同求</div>
                </div>
              </template>

              <template v-else>
                <div class="collect-default" v-if="vo.integral">
                  消耗积分{{ vo.integral }}
                </div>
              </template>



            </div>

            <!--  会员专属图标  -->
            <MembersOnlyTag class="member-icon"></MembersOnlyTag>
          </div>

          <div class="demand-contain">
            <div class="demand-title overflow-one">{{ vo.title }}</div>
            <div class="demand-info">
              <div class="demand-pic-type">
                <i class="iconfont icon-cart2"/>
                {{ vo.category_name }}
              </div>
              <div class="demand-design-status">
                <i class="iconfont icon-jindu"/>
                {{ vo._status }}
              </div>
            </div>
            <UserMemberIcons :item="vo"/>
          </div>

          <!--  查看需求 -->
          <div class="demand-watch">
            <div class="demand-watch-mask"></div>
            <div class="demand-watch-btn">查看需求</div>
          </div>

          <!--  完成状态 -->
          <div class="demand-status" v-if="vo.status == 3"></div>
          <div class="demand-status-cancel" v-if="vo.status == 2"></div>
        </a>

        <a class="demand-item " v-else>
          <div class="ranking-title ranking-z-10">需求精品榜</div>
          <div class="ranking-desc ranking-z-10">Demand list</div>
          <div class="ranking-list ranking-z-10">
            <a class="ranking-item"
               :href="item._link_url"
               target="_blank"
               v-for="(item,index) in rankingList.slice(0,sliceVal)"
               :key="index"
            >
              <span class="ranking-index"
                    :class=" 'ranking-index' + (index+1) "
              >
                {{ index + 1 }}
              </span>
              <span class="ranking-message overflow-one">{{ item.title }}</span>

              <!--  火苗-->
              <div class="icon_hot-box" v-if="index == 0">
                <i class="icon_hot"></i>
                <i class="icon_hot"></i>
                <i class="icon_hot"></i>
              </div>

              <div class="icon_hot-box" v-if="index == 1">
                <i class="icon_hot"></i>
                <i class="icon_hot"></i>
              </div>

              <div class="icon_hot-box" v-if="index == 2">
                <i class="icon_hot"></i>
              </div>
            </a>
          </div>
        </a>


      </div>


    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import MembersOnlyTag from '@/components/fans/members-only-tag';
import UserMemberIcons from '@/components/fans/user-member-icons';
import {fnFans, fnLogin} from "@/fn";
import {toggleMaterialCollect} from "@/api/material";
import {toggleDemandCollect} from "@/api/fans/demand-pool";

export default {
  name: "FansDemandPoolList",
  components: {
    MembersOnlyTag,
    UserMemberIcons
  },
  data() {
    return {
      sliceVal: 8
    }
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    rankingList: {
      type: Array,
      default: () => []
    },
    type:''
  },
  computed: {
    ...mapState('user', ['avatar'])
  },
  mounted() {
    this.initViewWidth();
    window.onresize = () => {
      this.initViewWidth();
      this.$emit('resize')
    }
  },
  methods: {
    toggleCollect(info) {
      let {vo, idx} = info;
      if (fnLogin.checkLogin()) {
        let isCollect = vo.is_collected || false
        toggleDemandCollect({
          id: vo.id,
          mode: isCollect === false ? 'add' : 'rem',
        }).then(res => {
          let msg = isCollect === false ? '收藏成功' : '已取消收藏';
          vo.collect_users = parseInt(vo.collect_users);
          let _collect_users = isCollect === false ? vo.collect_users += 1 : vo.collect_users -= 1;
          this.$set(vo, 'is_collected', !vo.is_collected)
          this.$set(vo, 'collect_users', _collect_users)
          this.$myNotify.success(msg);
        })
      } else {
        fnLogin.loginIntercept('请先登录');
      }
    },

    initViewWidth() {
      this.sliceVal = document.body.clientWidth > 1440 ? 8 : 6
    },
  },
}
</script>

<style lang="scss" scoped>
.FansDemandPoolList {

  .inner_center {
    display: flex;
    flex-wrap: wrap;
  }

  .demand-item {
    display: inline-block;
    width: 336px;
    height: 440px;
    background: #FFFFFF;
    box-shadow: 0px 8px 16px 0px rgba(213, 221, 236, 0.4);
    margin: 0 32px 40px 0;
    border-radius: 14px;
    overflow: hidden;
    position: relative;
    cursor: pointer;

    &:hover {

      /* .demand-item-pic{
         height: 100%;

       }
       .demand-support{
         top: 24px;
       }

       .demand-watch{
         bottom: 0;
       }*/
    }

    .demand-item-pic {
      width: 100%;
      height: 326px;
      background: #FFFFFF;
      border-radius: 1px;
      position: relative;
      //overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.5s ease;

      .pic-mask {
        width: 100%;
        height: 100%;
        @include Position(1, 5, 0, 0);
        backdrop-filter: blur(100px);
        filter: blur(100px);
        opacity: 0.5;
        background: url("https://pic-oss.chaopx.com/chao_origin_pic/23/01/09/522eb621e9cb214b472753e4722e79b7.jpg") no-repeat center center;
      }

      .pic-color-mask {
        width: 100%;
        height: 100%;
        @include Position(1, 5, 0, 0);
        color: rgba(255, 255, 255, 0.65);
        backdrop-filter: blur(20px);
        filter: blur(20px);
      }

      img {
        display: flex;
        height: 100%;
        position: relative;
        z-index: 3;
        max-height: 250px;
      }

      .member-icon {

        @include Position(1, 5, 14px, 14px);
        z-index: 10;


      }


      &:hover {
        height: 100%;

        .demand-support {
          //top: 24px;
        }

        .member-icon {
          display: none;
        }
      }
    }


    .demand-contain {
      padding: 16px 18px 0;

      .demand-title {
        width: 210px;
        height: 21px;
        font-size: 16px;
        font-weight: bold;
        color: #0A2540;
        line-height: 21px;
        letter-spacing: 1px;
        margin-bottom: 8px;
      }

      .demand-info {
        display: flex;
        align-items: center;
        color: #596080;
        margin-bottom: 11px;

        .iconfont {
          font-size: 16px;
          margin-right: 4px;
          position: relative;
          top: 1px;
        }

        .demand-pic-type {
          margin-right: 14px;
          @include LayoutFlex(1);
        }

        .demand-design-status {
          @include LayoutFlex(1);
        }
      }

      .demand-user {
        display: flex;
        align-items: center;

        .demand-user-avatar {
          display: inline-block;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          border: 1px solid rgba(255, 255, 255, 0.6);
        }

        .demand-user-id {
          height: 17px;
          font-size: 13px;
          color: #596080;
          line-height: 17px;
          margin: 0 4px 0 8px;
        }

        .demand-user-vip {

          .member-person {
            @include BgImage(22px, 22px, $member-person)
          }

          .member-business {
            @include BgImage(22px, 22px, $member-business)
          }

          .member-company {
            @include BgImage(22px, 22px, $member-company)
          }
        }

      }
    }

    .demand-watch {
      @include Position(1, 4, 0, -500px);
      z-index: 6;
      width: 100%;
      height: 156px;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.15) 52%, rgba(0, 0, 0, 0.3) 100%);
      border-radius: 0px 0px 14px 14px;
      transition: all 0.5s ease;

      .demand-watch-btn {
        width: 200px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #FFFFFF;
        border-radius: 27px;
        border: 1px solid #FF6D7C;
        margin: 18px auto;
        font-size: 16px;
        color: #FF6D7C;

        &:hover {
          background: $color-fans;
          color: #FFFFFF;
        }

      }
    }

    .demand-support {
      @include Position(1, 2, 0, 309px);
      z-index: 10;
      cursor: pointer;
      transition: all 0.5s ease;

      .collect-default {
        width: 100px;
        height: 34px;
        background: #FF5D6E;
        box-shadow: 0px 2px 4px 0px rgba(255, 93, 110, 0.3);
        border-radius: 19px 0px 0px 19px;
        font-size: 13px;
        color: #FFFFFF;
        line-height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;

        .line {
          display: inline-block;
          width: 1px;
          height: 10px;
          border-radius: 1px;
          background: rgba(255, 255, 255, 0.46);
          margin: 0 5px;
        }

        &:hover {
          background: #FF6D7C;
        }
      }


      .collect-succ {
        width: 100px;
        height: 34px;
        background: #FFFFFF;
        box-shadow: 0px 2px 4px 0px rgba(255, 93, 110, 0.15);
        border-radius: 19px 0px 0px 19px;
        font-size: 13px;
        color: #FF6D7C;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          .collect-cancel {
            display: block;
          }

          .collect-person {
            display: none;
          }
        }

        .collect-cancel {
          display: none;
        }
      }


      /*&:hover{
        background: #FF6D7C;
      }*/
    }

    .demand-status {
      @include BgImage(88px, 88px, 'fans/demand-pool/status%40finish.png');
      @include Position(1, 3, 0, 0);
      z-index: 6;

      &.demand-status-cancel {
        @include BgImage(88px, 88px, 'fans/demand-pool/status@cancel.png');
      }
    }

    &:nth-child(4n) {
      margin-right: 0;
    }


    @include Screen(1) {
      margin: 0 28px 37px 0;
      width: 279px;
      height: 365px;

      .demand-item-pic {
        height: 250px;
      }

      .demand-contain {
        padding: 17px 20px 0;

        .demand-title {
          width: 210px;
          height: 21px;
          font-size: 16px;
          font-weight: bold;
          color: #0A2540;
          line-height: 21px;
          letter-spacing: 1px;
        }
      }

      .demand-support {
        top: 233px;
      }
    }
  }


  .demand-item-ranking {
    position: relative;
    box-shadow: none !important;
    background: transparent;
    overflow: visible;

    .demand-item {
      background: transparent;
      padding: 26px 0 0;
      box-sizing: border-box;
      overflow: visible;
      box-shadow: none !important;


      &:after {
        content: "";
        display: inline-block;
        @include Position(1, 5, 50%, 52%);
        transform: translate(-50%, -50%);
        @include BgImage(368px, 480px, 'fans/rank%40big.png');
      }

      @include Screen(1) {

        &:after {
          content: "";
          display: inline-block;
          @include Position(1, 5, 50%, 52%);
          transform: translate(-50%, -50%);
          @include BgImage(311px, 397px, 'fans/rank%40small.png?v=1');
        }
      }
    }


    .ranking-z-10 {
      position: relative;
      z-index: 10;
    }

    .ranking-title {
      height: 30px;
      font-size: 22px;
      font-weight: bold;
      color: #2D2B33;
      line-height: 29px;
      letter-spacing: 2px;
      padding: 0 22px 0 26px;
    }

    .ranking-desc {
      height: 22px;
      font-size: 16px;
      font-weight: bold;
      color: rgba(45, 43, 51, 0.1);
      line-height: 21px;
      letter-spacing: 1px;
      padding: 0 22px 14px 26px;
    }

    .ranking-list {

      .ranking-item {
        height: 42px;
        //background: #FFFFFF;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 0 22px 0 26px;
        position: relative;

        &:hover {
          background: linear-gradient(180deg, rgba(255, 243, 239, 0) 0%, rgba(255, 243, 239, 0.6) 100%);
        }


        .ranking-index {
          font-size: 14px;
          font-weight: bold;
          color: #CDCFD8;
          line-height: 19px;
          letter-spacing: 1px;
          margin-right: 12px;

          &.ranking-index1 {
            color: rgba(255, 43, 24, 1);
          }

          &.ranking-index2 {
            color: rgba(255, 191, 0, 1);
          }

          &.ranking-index3 {
            color: rgba(255, 116, 66, 1);
          }
        }

        .ranking-message {
          font-size: 14px;
          color: #424866;
          letter-spacing: 1px;

          max-width: 217px;
        }


        .icon_hot-box{
          @include Position(1,2,12px,50%);
          transform: translateY(-50%);
          font-size: 0;

          .icon_hot{
            @include BgImage(17px, 19px, 'fans/icon_hot.png?v=1');
            //margin-left: 3px;
          }
        }

      }


    }


    @include Screen(1) {


    }
  }

}
</style>
